import { render } from "./AddIncident.vue?vue&type=template&id=55f0fd94&ts=true"
import script from "./AddIncident.vue?vue&type=script&lang=ts"
export * from "./AddIncident.vue?vue&type=script&lang=ts"

import "./AddIncident.vue?vue&type=style&index=0&id=55f0fd94&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__